import "./PatientSupport.module.css";
import Header from "@/reusable_sections/Header";
import Faq from "./sections/Faq";
import ContactUs from "./sections/ContactUs";
import NationalHeadquarters from "./sections/NationalHeadquarters";
import Footer from "@/reusable_sections/Footer";
export default function PatientSupportPage() {
  return <div>
      <Header />
      <Faq />
      <ContactUs />
      <NationalHeadquarters />
      <Footer />
    </div>;
}